<div
  class="flex items-center gap-3 rounded-2xl bg-neutrals-0 p-3 ui-shadow-below md:w-[364px]"
>
  <!-- Badge stays 40px in the layout; the timer lottie ships with internal
       padding, so it renders at 56px and overflows the badge symmetrically to
       land at the ~40px visual size Figma shows. -->
  <div class="relative h-10 w-10 shrink-0 rounded-xl bg-critical-100">
    <ui-animation
      class="absolute left-1/2 top-1/2 block h-14 w-14 -translate-x-1/2 -translate-y-1/2"
      type="timer"
    ></ui-animation>
  </div>
  <div class="flex min-w-0 flex-1 flex-col gap-1">
    <div class="flex flex-col">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        font-weight="semibold"
        text-color="neutrals-900"
        content="Registros por vencer"
      />
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        font-weight="regular"
        text-color="neutrals-600"
        [content]="countLabel"
      />
    </div>
    <button
      type="button"
      class="w-fit cursor-pointer bg-transparent"
      (click)="viewRecords.emit()"
    >
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        font-weight="semibold"
        text-color="primary-500"
        content="Ver registros"
      />
    </button>
  </div>
  <button
    type="button"
    class="shrink-0 cursor-pointer bg-transparent"
    aria-label="Cerrar"
    (click)="dismissed.emit()"
  >
    <ui-icon
      name="close"
      size="20"
      mobile-size="20"
      fill="neutrals-600"
    ></ui-icon>
  </button>
</div>
